import React, { useEffect, useState } from 'react';
import './Home.css';
import { fetchData } from '../../config/dataService';
import config from '../../config/config';

function FeatureCard({ feature, index }) {
  const imageUrl = feature.image
    ? `${config.S3_IMAGES_BASE_URL}/homeImages/${feature.image}`
    : null;

  return (
    <div
      className={`home__feature-card${imageUrl ? ' home__feature-card--has-image' : ''} fade-up`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      {imageUrl && (
        <div className="home__feature-image-wrap">
          <img
            className="home__feature-image"
            src={imageUrl}
            alt={feature.imageAlt || feature.title}
            loading="lazy"
          />
        </div>
      )}
      <div className="home__feature-body">
        {!imageUrl && (
          <div className="home__feature-icon">{feature.icon}</div>
        )}
        <h3 className="home__feature-title">{feature.title}</h3>
        <p className="home__feature-desc">{feature.description}</p>
      </div>
    </div>
  );
}

export default function Home() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    fetchData('home')
      .then(setData)
      .catch(setError)
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-state">Loading…</div>;
  if (error)   return <div className="error-state">Could not load content. Please try again.</div>;

  const { about = {}, features = [] } = data || {};

  // Separate features with and without images so we can lay them out optimally
  const hasAnyImage = features.some(f => f.image);

  return (
    <main>

      {/* ── About ── */}
      <section className="home__about">
        <div className="container">
          <div className="home__about-inner">
            <div className="home__about-text">
              <h2 className="section-title">{about.title || 'About Us'}</h2>
              <div className="divider" />
              {(about.paragraphs || []).map((p, i) => (
                <p key={i} className="home__about-body">{p}</p>
              ))}
              {about.pullQuote && (
                <blockquote className="home__about-highlight">{about.pullQuote}</blockquote>
              )}
            </div>
            <div className="home__about-visual">
              {about.image && (
                <img
                  src={about.image}
                  alt={about.imageAlt || ''}
                  style={{ borderRadius: 'var(--radius-lg)', boxShadow: 'var(--shadow-lg)' }}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ── Features ── */}
      {features.length > 0 && (
        <section className="home__features">
          <div className="container">
            <h2 className="section-title">What We Offer</h2>
            <div className="divider" />
            <div className={`home__features-grid${hasAnyImage ? ' home__features-grid--with-images' : ''}`}>
              {features.map((f, i) => (
                <FeatureCard key={i} feature={f} index={i} />
              ))}
            </div>
          </div>
        </section>
      )}

    </main>
  );
}
